<p>
  {{ label }}
  <strong>{{ rowCount }}</strong>
</p>

<ng-container *ngrxLet="isWideView$ as isWideView">
  <ng-container *ngIf="isWideView">
    <table
      mat-table
      class="dynamic-form-table__table pb-1 w-100"
      seperation="alt"
      [dataSource]="data"
      [trackBy]="trackByFn"
    >
      <ng-container
        *ngFor="let columnId of columnIds"
        [matColumnDef]="columnId"
      >
        <td mat-cell class="dynamic-form-table__cell bold" *matHeaderCellDef>
          {{ columnsMeta[columnId]?.label }}
        </td>
        <td
          mat-cell
          class="dynamic-form-table__cell"
          *matCellDef="let element; let index = index"
        >
          <lockton-apps-dynamic-form-cell
            *ngIf="columnId !== 'actions'"
            [type]="columnsMeta[columnId].type"
            [value]="element.item[columnId]"
            [addonLeft]="columnsMeta[columnId].addonLeft"
            [addonRight]="columnsMeta[columnId].addonRight"
            [decimalFormat]="columnsMeta[columnId].decimalFormat"
            [options]="columnsMeta[columnId].options$ | async"
            (customEvent)="customEvent.emit($event)"
          ></lockton-apps-dynamic-form-cell>

          <ng-container *ngIf="columnId === 'actions'">
            <ng-container
              *ngTemplateOutlet="
                actionsTmpl;
                context: { $implicit: element.__meta.id }
              "
            ></ng-container>
          </ng-container>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnIds"></tr>
      <tr
        mat-row
        @listItem
        (@listItem.done)="animationDone.emit($event)"
        *matRowDef="let row; columns: columnIds"
        class="dynamic-form-table__row"
        [class.dynamic-form-table__row--invalid]="!row.__meta.valid"
      ></tr>
    </table>

    <mat-error *ngIf="hasInvalidRows" i18n>*Incomplete entry</mat-error>
  </ng-container>

  <ng-container *ngIf="!isWideView">
    <lockton-apps-dynamic-form-card
      *ngFor="let element of data; trackBy: trackByFn"
      @listItem
      (@listItem.done)="animationDone.emit($event)"
      class="w-100"
      [fields]="fields"
      [item]="element.item"
      [alt]="true"
      [invalid]="!element.__meta.valid"
      (edit)="edit.emit(element.__meta.id)"
      (delete)="delete.emit(element.__meta.id)"
      (customEvent)="customEvent.emit($event)"
    ></lockton-apps-dynamic-form-card>
  </ng-container>
</ng-container>

<div
  class="d-flex justify-content-center"
  *ngIf="rows.length > limit && !print"
>
  <button
    class="dynamic-form-table__expand-button mt-2"
    luiTextButton
    type="button"
    iconPosition="end"
    (click)="toggleRowsVisibility()"
  >
    <span *ngIf="!showAllRows" i18n>View more</span>
    <span *ngIf="showAllRows" i18n>View less</span>
    <mat-icon
      [svgIcon]="showAllRows ? 'chevron_up' : 'chevron_down'"
    ></mat-icon>
  </button>
</div>

<ng-template #actionsTmpl let-index>
  <lui-context-menu-container class="p-0">
    <button
      type="button"
      [luiContextMenuButtonFor]
      [matMenuTriggerFor]="actionsMenu"
    >
      <mat-icon svgIcon="more"></mat-icon>
    </button>

    <mat-menu #actionsMenu="matMenu" xPosition="before">
      <button mat-menu-item (click)="edit.emit(index)">
        <mat-icon svgIcon="edit"></mat-icon>
        <span i18n>Edit</span>
      </button>
      <button mat-menu-item (click)="delete.emit(index)">
        <mat-icon svgIcon="delete"></mat-icon>
        <span i18n>Delete</span>
      </button>
    </mat-menu>
  </lui-context-menu-container>
</ng-template>
